import React, {  useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import SurveyRating from "./components/SurveyRating";
import { nextPage } from "../../store/page/actions";
import { Container } from "./style";
import { WebchatContext } from "../../context/WebchatContext";

const END = "End";

const CustumerExperienceSurvey = ({ config }) => {
  const { isMobile } = useContext(WebchatContext);

  const questionMain = useSelector((state) => state.survey.questionMain);
  const pendingSurveyId = useSelector((state) => state.survey.pendingSurveyId);
  const active = useSelector((state) => state.survey.active);
  const dispatch = useDispatch();

  if (!questionMain) {
    dispatch(nextPage(END));
  }

  return (
    <Container isMobile={isMobile}>
      {questionMain && (
        <>
          <SurveyRating
            questionMain={questionMain}
            pendingSurveyId={pendingSurveyId}
            active={active}
            config={config}
          />
        </>
      )}
    </Container>
  );
};

export default CustumerExperienceSurvey;
